import { render, staticRenderFns } from "./ChallengeApproveItem.vue?vue&type=template&id=60dab258&scoped=true&"
import script from "./ChallengeApproveItem.vue?vue&type=script&lang=js&"
export * from "./ChallengeApproveItem.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeApproveItem.vue?vue&type=style&index=0&id=60dab258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dab258",
  null
  
)

export default component.exports